const interceptors = [];

function fetchWithHeaders(
    url,
    { headers = {}, ...additionalRequestOptions } = {}
) {
    const requestOptions = {
        credentials: 'same-origin',
        headers: {
            accept: 'application/json',
            ...interceptors.reduce(
                (a, b) => ({
                    ...a,
                    ...b(additionalRequestOptions),
                }),
                {}
            ),
            ...headers,
        },
        ...additionalRequestOptions,
    };

    return window.fetch(url, requestOptions).then(response => {
        if (!response.ok) {
            return Promise.reject(response);
        }

        return response;
    });
}

export function addHeaderRequestInterceptor(interceptor) {
    interceptors.push(interceptor);
}

export function removeHeaderRequestInterceptor(interceptor) {
    const index = interceptors.indexOf(interceptor);
    if (index === -1) {
        throw new Error('No such interceptor');
    }

    interceptors.splice(index, 1);
}

export function get(url, requestOptions = {}) {
    return fetchWithHeaders(url, { method: 'GET', ...requestOptions });
}

export function del(url, requestOptions = {}) {
    return fetchWithHeaders(url, { method: 'DELETE', ...requestOptions });
}

export function post(url, body, additionalRequestOptions = {}) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'content-type': 'application/json',
        },
        ...additionalRequestOptions,
    };

    return fetchWithHeaders(url, requestOptions);
}

export function put(url, body, additionalRequestOptions = {}) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
            'content-type': 'application/json',
        },
        ...additionalRequestOptions,
    };

    return fetchWithHeaders(url, requestOptions);
}



// WEBPACK FOOTER //
// ./services/jsonfetchservice.js